import styled from 'styled-components';
import Button from '../../button/Button';
import RoundedCheckbox from '../../checkbox/RoundedCheckbox';
import Typography from '../../typography/Typography';
import SelectModal from '../select-modal/SelectModal';
// TIP this is used because styled components do not support components with generic types
const StyledSelectModal = styled(SelectModal) ``;
export const MultiSelectContainer = styled.div `
  ${StyledSelectModal} {
    height: 4rem;

    border-radius: ${({ theme }) => theme.borderRadius.highL};

    .select-dropdown-icon {
      display: none;
    }

    background-color: ${({ theme, isSelected }) => isSelected
    ? theme.colors.interactive.brandColor
    : theme.colors.surface.default};

    ${({ theme }) => {
    const backColor = theme.colors.surface
        .interactiveDefault;
    const radius = theme.borderRadius
        .mediumHigh;
    return theme.media.tablet `
          height: 5.4rem;
      
          border-radius: ${radius};

          background-color:${backColor};
          .select-dropdown-icon {
              display: block;
          }
    `;
}};
  }
`;
export const CustomSelectModal = StyledSelectModal;
export const CustomRoundedCheckbox = styled(RoundedCheckbox) `
  background-color: ${({ theme }) => theme.colors.surface.default};
  border: none;
  border-radius: unset;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
  height: unset;
  padding: 1.6rem;
  ${({ theme }) => theme.media.tablet `
    border: none;
    
  `};

  &&& {
    svg {
      display: block;
    }
  }
`;
export const MultiSelectValueContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const CustomTypography = styled(Typography) `
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
export const OptionHeaderContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 1.1rem 1.8rem;

  cursor: default;
`;
export const FooterButtonWrapper = styled.div `
  display: flex;
  cursor: default;
  margin: 1.6rem 1.5rem;
  gap: 0;
  box-shadow: ${({ theme }) => theme.shadows.white_upper};
  ${({ theme }) => theme.media.tablet `
   padding: 1.5rem;
   margin:0;
   gap:1.6rem;
  `};
`;
export const SelectValueContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  height: 100%;
`;
export const CustomButton = styled(Button) `
  border-radius: ${({ theme }) => theme.borderRadius.x2};
  height: 6rem;
  ${({ theme }) => theme.media.tablet `
      height:4.8rem;
  `};
`;
export const CustomClearButton = styled(Button) `
  border-radius: ${({ theme }) => theme.borderRadius.x2};
  display: none;
  &:disabled {
    opacity: 1;
  }
  ${({ theme }) => theme.media.tablet `
      display:block;
  `};
`;
//# sourceMappingURL=styles.js.map